var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/region.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
output += "\n\n";
output += "\n\n";
output += "\n\n";
var t_1;
t_1 = (lineno = 22, colno = 40, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"getSiteBySiteId"), "helpers[\"getSiteBySiteId\"]", context, [runtime.contextOrFrameLookup(context, frame, "state")]));
frame.set("siteIndex", t_1, true);
if(frame.topLevel) {
context.setVariable("siteIndex", t_1);
}
if(frame.topLevel) {
context.addExport("siteIndex", t_1);
}
if((lineno = 28, colno = 15, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"])) && runtime.memberLookup(((lineno = 28, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address") && runtime.memberLookup((runtime.memberLookup(((lineno = 28, colno = 71, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"groupType")) {
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup(((lineno = 30, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"groupType");
frame.set("currentGroupType", t_2, true);
if(frame.topLevel) {
context.setVariable("currentGroupType", t_2);
}
if(frame.topLevel) {
context.addExport("currentGroupType", t_2);
}
var t_3;
t_3 = (lineno = 32, colno = 64, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"getCountryIndexBySelectedCountry"), "helpers[\"getCountryIndexBySelectedCountry\"]", context, [runtime.contextOrFrameLookup(context, frame, "state")]));
frame.set("countryIndex", t_3, true);
if(frame.topLevel) {
context.setVariable("countryIndex", t_3);
}
if(frame.topLevel) {
context.addExport("countryIndex", t_3);
}
;
}
else {
var t_4;
t_4 = runtime.contextOrFrameLookup(context, frame, "groupType");
frame.set("currentGroupType", t_4, true);
if(frame.topLevel) {
context.setVariable("currentGroupType", t_4);
}
if(frame.topLevel) {
context.addExport("currentGroupType", t_4);
}
var t_5;
t_5 = (lineno = 38, colno = 64, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"getCountryIndexBySelectedCountry"), "helpers[\"getCountryIndexBySelectedCountry\"]", context, [runtime.contextOrFrameLookup(context, frame, "state")]));
frame.set("countryIndex", t_5, true);
if(frame.topLevel) {
context.setVariable("countryIndex", t_5);
}
if(frame.topLevel) {
context.addExport("countryIndex", t_5);
}
;
}
output += "<div class=\"c-form__field\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group1") {
output += "\n\n        <label for=\"address.region\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 46, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupOne-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += " &#42;</label>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group2" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group8") {
output += "\n\n        <label for=\"address.region\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 50, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupTwo-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += " </label>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group3") {
output += "\n\n        <label for=\"address.region\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 54, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupThree-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += " </label>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group4") {
output += "\n        <label for=\"address.region\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 57, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupFour-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += " &#42;</label>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group5") {
output += "\n\n        <label for=\"address.region\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 61, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupFive-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += " &#42;</label>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group6" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group7") {
output += "\n\n        <label for=\"address.region\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 65, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupSix-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</label>\n\n    ";
;
}
else {
output += "\n\n        <label for=\"address.region\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 69, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</label>\n\n    ";
;
}
;
}
;
}
;
}
;
}
;
}
output += "\n\n    ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"siteConfig")),"allCountries")),runtime.contextOrFrameLookup(context, frame, "countryIndex"))),"regions")) > 0 && (runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group1" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group4" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group5")) {
output += "<select class=\"js-address-form-item c-form__select\" name=\"address.region\" id=\"address.region\" required aria-required=\"true\" aria-describedby=\"address.region_error\" data-qa-group1-address-region-select>\n\n            ";
output += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group1") {
output += "\n                <option value=\"\" selected disabled=\"disabled\">";
output += runtime.suppressValue((lineno = 79, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-address-placeholder-region1",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</option>\n\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group4") {
output += "\n                <option value=\"\">";
output += runtime.suppressValue((lineno = 82, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-address-placeholder-region4",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</option>\n\n            ";
;
}
else {
output += "\n                <option value=\"\">";
output += runtime.suppressValue((lineno = 85, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-countryGroups-groupOne-selectRegion-aus",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</option>\n\n            ";
;
}
;
}
output += "\n\n            ";
output += "\n\n            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"siteConfig")),"allCountries")),runtime.contextOrFrameLookup(context, frame, "countryIndex"))),"regions");
if(t_8) {var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("region", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
output += "\n                ";
if(runtime.memberLookup((runtime.memberLookup(((lineno = 92, colno = 31, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"region") == runtime.memberLookup((t_9),"regionCode")) {
output += "\n                    <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"regionCode"), env.opts.autoescape);
output += "\" selected>";
output += runtime.suppressValue(runtime.memberLookup((t_9),"description"), env.opts.autoescape);
output += "</option>\n\n                ";
;
}
else {
output += "\n                    <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"regionCode"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_9),"description"), env.opts.autoescape);
output += "</option>\n\n                ";
;
}
output += "\n            ";
;
}
}
frame = frame.pop();
output += "\n\n        </select>\n\n    ";
output += "\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group2" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group8") {
output += "\n\n        <input type=\"text\" name=\"address.region\" id=\"address.region\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 106, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"region"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" aria-describedby=\"address.region_error\"/>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group3") {
output += "\n\n        <input type=\"text\" name=\"address.region\" id=\"address.region\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 110, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"region"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" aria-describedby=\"address.region_error\"/>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group6") {
output += "\n\n        <input type=\"text\" name=\"address.region\" id=\"address.region\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 114, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"region"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" aria-describedby=\"address.region_error\"/>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "groupType") == "group7") {
output += "\n\n        <input type=\"text\" name=\"address.region\" id=\"address.region\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 118, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"region"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" aria-describedby=\"address.region_error\"/>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group8") {
output += "\n\n        <input type=\"text\" name=\"address.region\" id=\"address.region\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 122, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"region"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" required aria-required=\"true\" aria-describedby=\"address.region_error\"/>\n\n    ";
;
}
else {
output += "\n\n        <input type=\"text\" name=\"address.region\" id=\"address.region\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 126, colno = 87, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"region"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" maxlength=\"35\" required aria-required=\"true\" aria-describedby=\"address.region_error\"/>\n\n    ";
;
}
;
}
;
}
;
}
;
}
;
}
output += "\n\n\n    ";
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group1" || runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group3") {
output += "\n\n        <span class=\"c-form-message\" data-qa-error-field=\"region\" id=\"address.region_error\">";
output += runtime.suppressValue((lineno = 135, colno = 93, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_validations-region",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</span>\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentGroupType") == "group6") {
output += "\n\n        <span class=\"c-form-message\" data-qa-error-field=\"county\" id=\"address.country_error\">";
output += runtime.suppressValue((lineno = 139, colno = 94, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_validations-county",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "</span>\n\n    ";
;
}
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/region.j2"] , dependencies)